<!-- 
 * @author song
 * @since 2022-04-21
 * @publisher  宏脉信息技术（广州）股份有限公司
 -->
<template>
  <div>
    <header style="display: flex;justify-content: space-between;">
      <div>
        <el-input
          placeholder="姓名"
          suffix-icon="el-icon-search"
          size="mini"
          @blur="searchFn"
          @clear="searchFn"
          v-model="formData.sceneName"
          clearable
          style="width: 180px; margin-right: 10px"
        >
        </el-input>
        <el-button-group>
          <span style="font-size: 14px;">导入时间:</span>
          <el-date-picker
            v-model="searchSelectTime"
            size="mini"
            type="daterange"
            :editable="false"
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="selectTime"
            clearable
            style="width: 240px; margin-right: 10px"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-button-group>
      </div>
    </header>
    <div class="table-content">
      <el-table
        ref="tableData"
        :data="tableData"
        :summary-method="getSummaries"   
        :show-summary="true"        
        style="width: 100%"
        height="calc(100vh - 290px)"
      >
        <el-table-column prop="empName" label="职员姓名" width="180">
        </el-table-column>
        <el-table-column prop="total" label="分配总量" width="180">
        </el-table-column>
        <el-table-column prop="notAdded" label="未添加数量"> </el-table-column>
        <el-table-column prop="added" label="已添加数量"> </el-table-column>
        <el-table-column prop="approved" label="已通过数量"> </el-table-column>
        <el-table-column prop="passRate" label="通过率"> </el-table-column>
        <!-- <el-table-column prop="action" label="操作">
          <template slot-scope="scope">
            <a
              style="color: #409eff;cursor: pointer;"
              @click="handleEditRemark(scope.row)"  
              >编辑备注</a
            >
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <footer>
      <Pagination
        v-bind:childMsg="pageparm"
        :pageSizes="pageSizes"
        @callBack="callBack"
      ></Pagination>
    </footer>
    <Fount ref="fount" @upload="getDataList"></Fount>
  </div>
</template>

<script>
import { getStatisticList } from "../../../api/addFriends/addFriends.js";
import Fount from "./components/fount.vue";
import dayjs from "dayjs";

export default {
  name: "AllocationSituation",
  data() {
    return {
      formData: {
        sceneName: "",
        startTime: "",
        endTime: "",
      },
      searchSelectTime: [],
      tableData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      pageSizes: [10, 20, 50, 100, 200, 500],
    };
  },
  components: { Fount },
  created() {
    this.getDataList();
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.tableData.doLayout();
    });
  },
  methods: {
    // 合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => item[column.property]);
        if (values.length > 0 && index < 5) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        } else {
          sums[index] = `${!(sums[4] && sums[3]) ? 0 : (sums[4]/sums[3]*100).toFixed(2)}%`;
        }
      });
      // if (i ndex === 5) {
      //   sums[index] = `${(sums[4] / sums[3]) * 100}%`;
      // }
      console.log("总计XXXXXXXX", data, columns, sums);
      return sums;
    },
    handleClick() {},
    searchFn() {
      this.pageparm.currentPage = 1;
      this.getDataList();
    },
    async getDataList() {
      const res = await getStatisticList(
        {
          param: this.formData.sceneName,
          current: this.pageparm.currentPage,
          size: this.pageparm.pageSize,
          startTime: this.formData.startTime,
          endTime: this.formData.endTime,
        },
        localStorage.getItem("Authorization")
      );
      this.tableData = res.data.result;
      this.pageparm.total = res.data.total;
    },
    // 时间处理
    selectTime(dataTime) {
      if (dataTime == null) {
        this.formData.startTime = "";
        this.formData.endTime = "";
      } else {
        this.formData.startTime = dayjs(dataTime[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        this.formData.endTime = dayjs(dataTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      this.formData.pageNum = 1;
      this.getDataList();
    },
    // 分页回调
    callBack(parm) {
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.getDataList();
    },
    // 编辑
    handleEditRemark(val) {
      console.log("编辑备注", val);
      this.$refs.fount.dialogVisible = true;
      this.$refs.fount.title = "编辑备注";
      this.$refs.fount.form = {
        id: val.id,
        cusPhone: val.cusPhone,
        cusName: val.cusName,
        remark: val.remark,
      };
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-table {
  overflow: visible !important;
  .has-gutter{
    font-weight: 700;
  }
}
</style>
